import { useEffect } from "react";

let locks = 0;
let lastScrollY = 0;

export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return;

    const body = document.body;
    const docEl = document.documentElement;

    if (locks === 0) {
      lastScrollY = window.scrollY;
      const scrollbar = window.innerWidth - docEl.clientWidth; // desktop compensation
      body.style.position = "fixed";
      body.style.top = `-${lastScrollY}px`;
      body.style.width = "100%";
      if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`;
    }
    locks += 1;

    return () => {
      locks -= 1;
      if (locks === 0) {
        body.style.position = "";
        body.style.top = "";
        body.style.width = "";
        body.style.paddingRight = "";
        window.scrollTo(0, lastScrollY);
      }
    };
  }, [active]);
}